// Per-period action predicates for the Eligibility Administration UI. Each answers "should the UI
// PRESENT this action for a period in this state?" — never "is the transition allowed?" The backend
// re-validates every transition authoritatively; these exist only to gate affordances.
//
// Shared by the fleet-wide grid and the future single-franchise Franchise Details view, so both
// surfaces present the same actions from one source of truth. As write slices land this is the home
// for: canReject (here) · canConfirm · canEdit · canClose · canRejoin · canDeactivate — kept aligned
// with the backend transition rules (e.g. scripts/lib/eligibilityReject.js: rejectTransitionError).

// An active proposal (proposed / manual-review) can be rejected.
export const canReject = (p) =>
  p.eligibility_state === "proposed" || p.eligibility_state === "manual_review";

// An active proposal can also be confirmed (Confirm / Adjust & Confirm) — same applicability as
// reject; the two are the review decisions available on a pending proposal.
export const canConfirm = (p) =>
  p.eligibility_state === "proposed" || p.eligibility_state === "manual_review";

// An active confirmed period can be edited — changing its authoritative dates AFTER confirmation.
// Applies to both open ("Confirmed") and bounded ("Closed") periods (both are eligibility_state
// 'confirmed'; open vs closed is only the derived label). "Edit" consistently means modifying an
// already-authoritative period — never a proposal.
export const canEdit = (p) => p.eligibility_state === "confirmed";

// A manually created period (source='manual') may be HARD-DELETED. This predicate gates on PROVENANCE
// (source), not lifecycle state, because Delete removes a mistaken manual entry outright: proposed,
// migrated, and other system-created rows are never deletable. The backend re-enforces the same rule
// (scripts/lib/eligibilityDelete.js: deleteTransitionError).
export const canDelete = (p) => p.source === "manual";
